import React from "react";
import { useNavigate } from "react-router-dom";

export default function EarningsDemoPage() {
  const navigate = useNavigate();

  const rows = [
    { label: "Cadeaux reçus", value: "+ 42,80 €", icon: "🎁" },
    { label: "Lives", value: "+ 76,20 €", icon: "🎥" },
    { label: "Interactions", value: "+ 18,40 €", icon: "💬" },
  ];

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(35px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes glowPulse {
          0%,100% { box-shadow: 0 0 25px rgba(0,242,255,0.25); }
          50% { box-shadow: 0 0 70px rgba(0,242,255,0.85); }
        }

        @keyframes floatIcon {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-12px); }
        }

        @keyframes barGrow {
          from { height: 20px; }
          to { height: var(--bar-height); }
        }

        @keyframes scanLine {
          0% { transform: translateX(-120%); opacity: 0; }
          30% { opacity: 1; }
          100% { transform: translateX(120%); opacity: 0; }
        }

        @keyframes numberPulse {
          0%,100% { transform: scale(1); color: #ffffff; }
          50% { transform: scale(1.08); color: #00f2ff; }
        }
      `}</style>

      <button onClick={() => navigate(-1)} style={styles.back}>
        ← Retour
      </button>

      <div style={styles.wrapper}>
        <div style={styles.iconCircle}>
          <span style={styles.icon}>📊</span>
        </div>

        <h1 style={styles.title}>Suivi des gains</h1>

        <p style={styles.subtitle}>
          Une vision claire des interactions et des revenus générés.
        </p>

        <div style={styles.dashboard}>
          <div style={styles.chartCard}>
            <div style={styles.scan} />

            <h2 style={styles.cardTitle}>Évolution des revenus</h2>

            <div style={styles.chart}>
              <div style={{ ...styles.bar, "--bar-height": "95px" }}>Lun</div>
              <div style={{ ...styles.bar, "--bar-height": "145px" }}>Mar</div>
              <div style={{ ...styles.bar, "--bar-height": "120px" }}>Mer</div>
              <div style={{ ...styles.bar, "--bar-height": "180px" }}>Jeu</div>
              <div style={{ ...styles.bar, "--bar-height": "210px" }}>Ven</div>
            </div>
          </div>

          <div style={styles.totalCard}>
            <p style={styles.smallLabel}>Total estimé</p>
            <div style={styles.total}>137,40 €</div>
            <p style={styles.cleanText}>
              Gains suivis clairement : cadeaux, lives, interactions et revenus générés.
            </p>
          </div>
        </div>

        <div style={styles.rows}>
          {rows.map((item, index) => (
            <div key={index} style={styles.row}>
              <span style={styles.rowIcon}>{item.icon}</span>
              <span style={styles.rowLabel}>{item.label}</span>
              <strong style={styles.rowValue}>{item.value}</strong>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 34%), radial-gradient(circle at bottom left, rgba(0,145,255,0.18), transparent 32%), #03070d",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    padding: "32px 18px",
    overflowY: "auto",
  },

  back: {
    position: "fixed",
    top: 22,
    left: 22,
    zIndex: 10,
    padding: "11px 18px",
    borderRadius: 16,
    border: "1px solid rgba(0,242,255,0.45)",
    background: "rgba(0,12,20,0.9)",
    color: "#00f2ff",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 0 18px rgba(0,242,255,0.25)",
  },

  wrapper: {
    maxWidth: 1050,
    margin: "0 auto",
    paddingTop: 75,
    textAlign: "center",
    animation: "fadeUp 0.8s ease forwards",
  },

  iconCircle: {
    width: 120,
    height: 120,
    margin: "0 auto 26px",
    borderRadius: "50%",
    border: "2px solid rgba(0,242,255,0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: "glowPulse 2.4s infinite",
  },

  icon: {
    fontSize: 54,
    animation: "floatIcon 2.5s ease-in-out infinite",
  },

  title: {
    margin: "0 0 12px",
    fontSize: 52,
    fontWeight: 900,
    color: "#00f2ff",
    textShadow: "0 0 24px rgba(0,242,255,0.8)",
  },

  subtitle: {
    maxWidth: 760,
    margin: "0 auto 34px",
    fontSize: 21,
    lineHeight: 1.6,
    color: "#9befff",
  },

  dashboard: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 18,
    marginBottom: 20,
  },

  chartCard: {
    position: "relative",
    overflow: "hidden",
    padding: 24,
    borderRadius: 26,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.3)",
    boxShadow: "0 0 30px rgba(0,242,255,0.16)",
  },

  scan: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "70%",
    height: "100%",
    background:
      "linear-gradient(90deg, transparent, rgba(0,242,255,0.16), transparent)",
    animation: "scanLine 3s infinite",
  },

  cardTitle: {
    margin: "0 0 18px",
    color: "#fff",
    fontSize: 22,
  },

  chart: {
    height: 240,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    gap: 16,
  },

  bar: {
    width: 46,
    height: "var(--bar-height)",
    borderRadius: "14px 14px 6px 6px",
    background: "linear-gradient(180deg, #00f2ff, #006bff)",
    color: "#001018",
    fontSize: 12,
    fontWeight: 900,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    paddingBottom: 8,
    animation: "barGrow 1.4s ease-out forwards, glowPulse 3s infinite",
  },

  totalCard: {
    padding: 30,
    borderRadius: 26,
    background:
      "linear-gradient(180deg, rgba(0,242,255,0.16), rgba(0,12,20,0.85))",
    border: "1px solid rgba(0,242,255,0.4)",
    boxShadow: "0 0 35px rgba(0,242,255,0.22)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  smallLabel: {
    margin: 0,
    color: "#9befff",
    fontWeight: 800,
  },

  total: {
    margin: "14px 0",
    fontSize: 58,
    fontWeight: 900,
    color: "#00f2ff",
    textShadow: "0 0 25px rgba(0,242,255,0.9)",
    animation: "numberPulse 2s infinite",
  },

  cleanText: {
    margin: 0,
    color: "#d9fbff",
    lineHeight: 1.6,
  },

  rows: {
    display: "grid",
    gap: 12,
    maxWidth: 760,
    margin: "20px auto 0",
  },

  row: {
    padding: "16px 18px",
    borderRadius: 18,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.25)",
    display: "grid",
    gridTemplateColumns: "45px 1fr auto",
    alignItems: "center",
    textAlign: "left",
    boxShadow: "0 0 20px rgba(0,242,255,0.1)",
  },

  rowIcon: {
    fontSize: 26,
  },

  rowLabel: {
    color: "#cfffff",
    fontWeight: 800,
  },

  rowValue: {
    color: "#00f2ff",
    fontSize: 20,
  },
};